export default __webpack_public_path__ + "static/media/house-3.884fd18a.jpg";